import { render, staticRenderFns } from "./PageSelect.vue?vue&type=template&id=5319234f&scoped=true&"
import script from "./PageSelect.vue?vue&type=script&lang=js&"
export * from "./PageSelect.vue?vue&type=script&lang=js&"
import style0 from "./PageSelect.vue?vue&type=style&index=0&id=5319234f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319234f",
  null
  
)

export default component.exports